
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/project-management",
      function () {
        return require("private-next-pages/features/project-management.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/project-management"])
      });
    }
  